import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-monthly-att-det',
  templateUrl: './monthly-att-det.component.html',
  styleUrls: ['./monthly-att-det.component.css']
})
export class MonthlyAttDetComponent implements OnInit {
  title ="Monthly Attendance Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/monthly-attendance-details/monthly-att-det/monthly-att-det.component.ts